// GIS LAYER API ROUTES
import axios from 'axios';

export async function loadLayer(gisurl, token, tennantId, layerName, data) {
  return await axios({
    method: 'POST',
    url: `${gisurl}/gis/loadlayer/${tennantId}/${layerName}`,
    data: data,
    headers: {
      Authorization: 'Bearer ' + token,
      'Tenant-Name': tennantId,
      'Content-Type': 'application/json',
    },
  })
    .then((results) => results.data)
    .catch((err) => err);
}

export async function removeLayer(gisurl, token, tennantId, layerId) {
  return await axios({
    method: 'DELETE',
    url: `${gisurl}/gis/${tennantId}/${layerId}`,
    headers: {
      Authorization: 'Bearer ' + token,
      'Tenant-Name': tennantId,
      'Content-Type': 'application/json',
    },
  })
    .then((results) => results.data)
    .catch((err) => err);
}

export async function getGISLayers(gisurl, token, tenantName) {
  return await axios({
    method: 'GET',
    url: `${gisurl}/gis/${tenantName}/getLayerCatalog`,
    headers: {
      Authorization: 'Bearer ' + token,
      'Tenant-Name': tenantName,
      'Content-Type': 'application/json',
    },
  })
    .then((results) => results.data)
    .catch((err) => err);
}

export async function getPublicGISLayers(gisurl, tenantName) {
  const { data } = await axios({
    method: 'GET',
    url: `${gisurl}/gis/${tenantName}/public/getLayerCatalog`,
    headers: {
      'Tenant-Name': tenantName,
    },
  });
  return data;
}

export async function editLayerInfo(gisurl, token, tennantId, layerId, edits) {
  return await axios({
    method: 'PUT',
    url: `${gisurl}/gis/${tennantId}/${layerId}`,
    data: edits,
    headers: {
      Authorization: 'Bearer ' + token,
      'Tenant-Name': tennantId,
      'Content-Type': 'application/json',
    },
  })
    .then((results) => results.data)
    .catch((err) => err);
}

export async function getLayerInfo(gisurl, token, tennantId, layerId, x, y) {
  return await axios({
    method: 'GET',
    url: `${gisurl}/gis/${tennantId}/${layerId}/intersect`,
    data: { x, y },
    headers: {
      Authorization: 'Bearer ' + token,
      'Tenant-Name': tennantId,
      'Content-Type': 'application/json',
    },
  })
    .then((results) => results.data)
    .catch((err) => err);
}

// NOT USED NOW - Go directly to API
export async function getTileLayer(gisurl, token, x, y, z, layerId, tennantId) {
  return await axios({
    method: 'GET',
    url: `${gisurl}/gis/${tennantId}/${layerId}/${z}/${x}/${y}`,
    headers: {
      Authorization: 'Bearer ' + token,
      'Tenant-Name': tennantId,
      'Content-Type': 'application/json',
    },
  })
    .then((results) => results.data)
    .catch((err) => err);
}

// JSON document sent to Vector Tile Class
export function getVectorTileStyle(gisurl, layerId, type, layerName, style, maxscale) {
  // STYLE Spec for Vector TIles
  // https://docs.mapbox.com/mapbox-gl-js/style-spec/layers/

  if (!style) {
    style = {
      color: '#f79f34',
      outline: '#d9d9d9',
      size: 7,
      width: 4,
      opacity: 0.8,
      fillopacity: 0.5,
    };
  }
  // default line
  let styleType = {
    id: 'layer',
    type: 'line',
    source: layerId,
    'source-layer': layerId,
    paint: {
      'line-color': style.color,
      'line-width': style.width,
      'line-opacity': style.opacity,
    },
  };

  if (type === 'point') {
    styleType.type = 'circle';
    styleType.paint = {
      'circle-color': style.color,
      'circle-radius': style.size,
      // 'circle-stroke-color': style.outline,
      'circle-stroke-width': 2,
    };
  } else if (type === 'polygon') {
    styleType.type = 'fill';
    styleType.paint = {
      'fill-color': style.color,
      'fill-opacity': style.fillopacity,
      'fill-outline-color': style.outline, // limited to 1px width!
    };
  } else if (type === 'symbol') {
    /// NOT WORKING RIGHT NOW
    styleType.type = 'symbol';
    styleType.layout = {
      'icon-image': 'Park',
      'icon-size': 60,
    };
    styleType.paint = {
      color: style.color,
    };
  }

  return {
    id: layerId,
    title: layerName,
    parentName: 'User Layer',
    sprite:
      'https://cdn.arcgis.com/sharing/rest/content/items/75f4dfdff19e445395653121a95a85db/resources/sprites/',
    glyphs:
      'https://basemaps.arcgis.com/arcgis/rest/services/World_Basemap_v2/VectorTileServer/resources/fonts/{fontstack}/{range}.pbf',
    style: {
      sources: {
        [layerId]: {
          type: 'vector',
          minzoom: maxscale || 12,
          url: gisurl + '/gis/' + layerId,
          tiles: [gisurl + '/gis/' + layerId + '/{level}/{col}/{row}'],
        },
      },
      layers: [styleType],
    },
  };
}
